import { graphql, useFragment } from "react-relay";

import { useSeriesArticleSectionTag } from "scmp-app/components/article/article-render/series-article/hooks";
import type { Props as SpecialIndexProps } from "scmp-app/components/content/content-item-render/variants/special-index";
import type { getContentTypeName } from "scmp-app/components/content/helpers";
import type { hooksSpecialIndexContent$key } from "scmp-app/queries/__generated__/hooksSpecialIndexContent.graphql";

type UseTagParameter = {
  contentTypeName: ReturnType<typeof getContentTypeName>;
  reference: hooksSpecialIndexContent$key;
  variant: SpecialIndexProps["variant"];
};

export const useTag = ({ contentTypeName, reference, variant }: UseTagParameter) => {
  const content = useFragment(
    graphql`
      fragment hooksSpecialIndexContent on Content {
        ...hooksSeriesArticleSectionTagArticle
        topics {
          name
        }
      }
    `,
    reference,
  );

  const seriesArticleSectionTag = useSeriesArticleSectionTag(content);

  const firstTopicName = content.topics?.[0]?.name;

  switch (variant) {
    case "series":
      return seriesArticleSectionTag;
    case "talking-post":
      // CSpell:ignore Yonden Lhatoo
      return "Talking Post with Yonden Lhatoo";
    default:
      return firstTopicName ?? contentTypeName;
  }
};
